import type { EntityOptions } from 'models';
import { useCallback } from 'react';
import { routes } from 'routes/routes';

export const useGetPathToEntityDetail = () =>
  useCallback((id: string, options: EntityOptions) => {
    const { entityType } = options;

    switch (entityType) {
      case 'community':
        return routes.community.feed(id);
      case 'event':
        return routes.events.detail(id);
      case 'giving':
        return routes.giving.detail(id);
      case 'group':
        return routes.group.detail.scope(id);
      case 'organization':
        return routes.organization.detail(id);
      case 'program':
        return routes.program.about(id);
      case 'video':
        return routes.video.detail(id);
    }
  }, []);
